module.exports = __webpack_public_path__ + "media/images/icon_face-63b2034d40dca183774061e6977fdfaa.png";